import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicScenario} from '../../framework/parameters/BasicScenario';
import {UserContext} from '../message/UserContext';
import {UserContextCriteria} from './UserContextCriteria';

export class UserContextWrapper extends BaseWrapper<UserContext, UserContextCriteria, BasicScenario>  {}

